import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useOptionContext } from "../OptionContext/index.js";

/**
 * Renders custom option element.
 *
 * All additional props as passed through to the underlying element
 */
const Option = _ref => {
  let {
    as: ComponentToRender,
    children,
    ...props
  } = _ref;
  const option = useOptionContext();
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: option.optionElementRef,
    onMouseDown: evt => option.selectOption(evt),
    "aria-selected": option.isSelected,
    tabIndex: "-1",
    role: "option"
  }, props, {
    id: option.id
  }), children);
};
process.env.NODE_ENV !== "production" ? Option.propTypes = {
  /**
   * Underlying element to render
   */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  /**
   * Children
   */
  children: PropTypes.node
} : void 0;
Option.defaultProps = {
  as: 'li'
};
export default Option;